import React from 'react';
import FFLink from '../../../../components/FFLink';
import styles from '../../../contentfulPage.module.css';

/** @type import('@contentful/rich-text-react-renderer').NodeRenderer */
export default function Hyperlink(node, children) {
  return (
    <FFLink className={styles.link} url={node.data.uri}>
      {children}
    </FFLink>
  );
}
